export enum OptimizationTypesShorts {
  carry = 'c',
  total = 't',
  combined = 'co',
  high = 'h',
  medium = 'm',
  low = 'l',
}

export function GetOptimizationTypesShorts(s: string): OptimizationTypesShorts {
  switch (s.toLowerCase()) {
    case 'carry':
    case 'c':
      return OptimizationTypesShorts.carry;
    case 'total':
    case 't':
      return OptimizationTypesShorts.total;
    case 'combined':
    case 'co':
      return OptimizationTypesShorts.combined;
    case 'high':
    case 'h':
      return OptimizationTypesShorts.high;
    case 'medium':
    case 'm':
      return OptimizationTypesShorts.medium;
    case 'low':
    case 'l':
      return OptimizationTypesShorts.low;
    default:
      return OptimizationTypesShorts.carry;
  }
}
